module.exports = __webpack_public_path__ + "img/icon-info.7c591285.svg";